import Button from "components/common/Button";
//import { ReactComponent as PinIcon } from "assets/PinIcon.svg";
import { Radio, TextField } from "@mui/material";
import ThemeContext from "components/app/Context";
import DialogFormation from "components/common/DialogFormation";
import { saveFilterByType, setSavedFilter } from "components/common/Filters/Filters.slice";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import { updateInncodeUploadList } from "components/features/SME/sme.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { setSelectedMyList } from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import { setCorpViewSelectedTab, setCreateListError, setDialog } from "../../CorpUser.Slice";
import "./saveList.scss";

export default function SaveList() {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const navigate = useNavigate();
  const { isMobileScreen } = useContext(ThemeContext);
  const [selectedValue, setSelectedValue] = useState<string>("");
  const filters = useAppSelector((state) => state.filters.filters);
  const [payload, setPayload] = useState<any>({ title: "", description: "" });
  const overview = useAppSelector((state) => state.CorpDashboard.myView.properties.overview);
  const isSmeUser = useAppSelector((state) => state.app.isSmeUser);
  const isOpen = useAppSelector((state) => state.CorpDashboard.dialogs.saveList.isOpen);
  const createListError = useAppSelector((state) => state.CorpDashboard.createListError);

  useEffect(() => {
    setSelectedValue("");
    setPayload({ title: "", description: "" });
    dispatch(
      setCreateListError({
        isError: false,
        message: "",
        isInputError: false
      })
    );
  }, [isOpen]);

  const handleClose = () => {
    dispatch(setDialog({ dialogName: "saveList", isOpen: false, data: {} }));
  };

  const handleRadioCheck = (value: string) => {
    setPayload({ title: "", description: "" });
    setSelectedValue(value);
    dispatch(
      setCreateListError({
        isError: false,
        message: "",
        isInputError: false
      })
    );
  };

  const isFilterChecked = selectedValue === "filter";
  const isPropertyChecked = selectedValue === "property";
  const isConsultantChecked = selectedValue === "consultant";

  const getView = (title: string, description: string, view: string) => {
    return (
      <div className={view === selectedValue ? "child-view-conatiner-active" : "child-view-conatiner"}>
        <div className="child-view-conatiner-row">
          <Radio
            checked={
              view === "filter" ? isFilterChecked : view === "property" ? isPropertyChecked : isConsultantChecked
            }
            onChange={() => handleRadioCheck(view)}
          />
          <Typography color={tokens.Text.General.PrimaryHeadline} variant={"body2"} showBold>
            {title}
          </Typography>
        </div>
        <Typography color={tokens.Text.General.PrimaryBody} variant={"body2"}>
          {description}
        </Typography>
        {view === selectedValue && getActiveView(view)}
      </div>
    );
  };

  const getActiveView = (view: string) => {
    return (
      <div className="active-view">
        <div className="text-field-styling">
          <Typography variant="body2" className="list-name-label" color={tokens.Text.General.Secondary}>
            <span style={{ color: "red" }}>*</span>
            {translate("list.name.label")}
          </Typography>
          <TextField
            error={createListError.isInputError}
            className="list-desc-inputs"
            onChange={(value: any) => setPayload({ ...payload, title: value.target.value })}
            placeholder="List name here"
          />
          {createListError.isInputError && (
            <Typography color="red" variant={"label"}>
              {createListError.message}
            </Typography>
          )}
        </div>
        {view !== "filter" && (
          <div className="text-field-styling">
            <Typography variant="body2" className="list-name-label" color={tokens.Text.General.Secondary}>
              {translate("common.description")}
            </Typography>
            <TextField
              className="list-desc-desc"
              multiline
              rows={4}
              onChange={(value: any) => setPayload({ ...payload, description: value.target.value })}
              placeholder="Description here"
            />
          </div>
        )}
      </div>
    );
  };

  const checkNoInncode = () => {
    if (!overview?.inncodes?.split(",").map((code: any) => code.trim())?.length) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          variant: "error",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: "No inncode found."
        })
      );
      return true;
    }
    return false;
  };

  const checkAndRedirect = (res: any) => {
    setSelectedMyList(dispatch, res, isFilterChecked ? "dynamic" : isPropertyChecked ? "static" : "consultant");
    dispatch(
      setCreateListError({
        isError: false,
        message: "",
        isInputError: false
      })
    );
    navigate(`/myLists`, {
      state: {
        fromDashboard: true
      }
    });
    dispatch(setCorpViewSelectedTab({ type: "myList", val: 0 }));

    handleClose();
  };

  const handleSubmit = async () => {
    let props;
    if (isFilterChecked)
      props = {
        dynamic: [
          {
            name: payload?.title,
            filters: filters
          }
        ]
      };
    else if (isPropertyChecked) {
      if (checkNoInncode()) return;
      props = {
        static: [
          {
            name: payload?.title,
            description: payload?.description,
            filters: [
              {
                key: "inncode",
                options: overview?.inncodes?.split(",").map((code: any) => code.trim())
              }
            ]
          }
        ]
      };
    } else {
      if (checkNoInncode()) return;
      props = {
        name: payload?.title,
        description: payload?.description,
        mappings: overview?.inncodes
          ?.split(",")
          .map((code: any) => code.trim())
          ?.map((item: string) => {
            return { innCode: item };
          })
      };
      const response = await dispatch(updateInncodeUploadList(props));
      if (response?.payload?.errors) {
        dispatch(
          setCreateListError({
            isError: true,
            message: response?.payload?.errors?.[0]?.detail,
            isInputError: true
          })
        );
      } else if (response?.payload?.status < responseTypes.success_threshold) {
        dispatch(
          setSavedFilter({
            name: "consultant",
            data: response?.payload?.data?.scList
          })
        );
        checkAndRedirect(response?.payload?.data?.scList);
        return;
      }
      return;
    }

    const res = await dispatch(saveFilterByType(props));
    if (res?.payload?.data?.errors) {
      dispatch(
        setCreateListError({
          isError: true,
          message: res?.payload?.data?.errors?.[0]?.detail,
          isInputError: true
        })
      );
    } else if (res.payload?.status === 200)
      checkAndRedirect(
        res?.payload?.data?.[isFilterChecked ? "dynamic" : "static"]?.find((item: any) => item?.name === payload?.title)
      );
  };

  return (
    <DialogFormation
      title={translate("dashboard.saveListTitle")}
      openDialog={isOpen}
      handleClose={handleClose}
      actionConfig={
        <div className="modal-config-wrapper">
          <Button variant="secondary" label="Cancel" onClick={handleClose} width={isMobileScreen ? "50%" : "25%"} />
          <Button
            disabled={!payload?.title}
            variant="primary"
            label="Save"
            onClick={() => handleSubmit()}
            width={isMobileScreen ? "50%" : "25%"}
          />
        </div>
      }
    >
      <div className="parent-view-container">
        {getView(translate("dashboard.saveFilters"), translate("dashboard.saveFiltersDescription"), "filter")}
        {getView(translate("dashboard.saveProperty"), translate("dashboard.savePropertyDescription"), "property")}
        {isSmeUser &&
          getView(
            translate("dashboard.saveConsultant"),
            translate("dashboard.saveConsultantDescription"),
            "consultant"
          )}
      </div>
    </DialogFormation>
  );
}
